"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSummaryPanelWidget = void 0;
var React = require("react");
var LookupWidgetBase_1 = require("../../LookupWidgetBase");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var QuoteSummaryPanelWidget = /** @class */ (function (_super) {
    __extends(QuoteSummaryPanelWidget, _super);
    function QuoteSummaryPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.getVehiclesAdditionalDrivers = function (interaction) {
            var vehicleDrivers = new Set();
            interaction.vehicles.forEach(function (vehicle) {
                vehicle.driverIds.forEach(function (driverId) {
                    var driver = interaction.additionalDrivers.find(function (driver) { return driverId === driver.personId && interaction.policyHolder.personId !== driver.personId; });
                    if (driver) {
                        vehicleDrivers.add(driver);
                    }
                });
            });
            return Array.from(vehicleDrivers);
        };
        _this.navigateToEditCar = _this.navigateToEditCar.bind(_this);
        _this.navigateToEditPolicyHolder = _this.navigateToEditPolicyHolder.bind(_this);
        _this.navigateToEditAdditionalDriver = _this.navigateToEditAdditionalDriver.bind(_this);
        return _this;
    }
    QuoteSummaryPanelWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("vehicleTransmission");
        this.fetchLookupValues("vehicleFuelType");
    };
    QuoteSummaryPanelWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        return (React.createElement("div", { className: "quote-summary-panel" },
            React.createElement("div", { className: "summary-section" },
                React.createElement("div", { className: "summary-heading" }, "Cover details"),
                this.renderCoverDetails(interaction)),
            React.createElement("div", { className: "summary-section" },
                React.createElement("div", { className: "summary-heading" }, interaction.vehicles && interaction.vehicles.length > 1 ? "Cars details" : "Car details"),
                this.renderCarsDetails(interaction)),
            React.createElement("div", { className: "summary-section" },
                React.createElement("div", { className: "summary-heading" }, interaction.additionalDrivers && interaction.additionalDrivers.length > 0 ? "Drivers details" : "Driver details"),
                this.renderDriversDetails(interaction))));
    };
    QuoteSummaryPanelWidget.prototype.renderCoverDetails = function (interaction) {
        return (React.createElement("div", { className: "summary-contents" },
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Price"),
                React.createElement("div", { className: "justify-content-center row mb-4 price font-family-display font-weight-semi-bold" },
                    React.createElement("div", { className: "fs-22" }, "".concat(interaction.factors.additionalPremium ? (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.additionalPremium) : (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.premium))))),
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Cover start"),
                React.createElement("div", { className: "justify-content-center row mb-4", id: "coverStartDate" }, (0, commonFunctions_1.convertDate)(interaction.headerInfo.startDate, "DD/MM/YYYY"))),
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Cover end"),
                React.createElement("div", { className: "justify-content-center row mb-4" }, "Anytime")),
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Guaranteed hire car"),
                React.createElement("div", { className: "justify-content-center row mb-4 text-center" }, this.renderExtraProtectionIncluded(interaction.vehicles, "courtesyCar"))),
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Motor legal expenses"),
                React.createElement("div", { className: "justify-content-center row mb-4 text-center" }, this.renderExtraProtectionIncluded(interaction.vehicles, "legalProtection")))));
    };
    QuoteSummaryPanelWidget.prototype.renderCarsDetails = function (interaction) {
        var _this = this;
        var vehicles = interaction.vehicles;
        return vehicles.map(function (vehicle, index) { return (React.createElement("div", { key: index, className: "summary-contents" },
            React.createElement("div", { className: "summary-contents-header" },
                React.createElement("img", { className: "vehicle-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png"), alt: "Vehicle icon" }),
                React.createElement("div", { className: "subject" }, "".concat(vehicle.make, ", ").concat(vehicle.model, ", ").concat(vehicle.year, ",\n                        ").concat(_this.resolveLookupValue("vehicleTransmission", vehicle.transmission), ",\n                        ").concat(_this.resolveLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicle.fuelType, vehicle.fuelTypeFull)))),
                React.createElement("div", null,
                    React.createElement("a", { className: "link-edit", onClick: function () { return _this.navigateToEditCar(index); } }, "Edit"))),
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Voluntary excess"),
                React.createElement("div", { className: "justify-content-center row mb-4" }, "\u00A3".concat(vehicle.excesses.voluntaryExcess))),
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, vehicle.driverIds && vehicle.driverIds.length > 1 ? "Drivers" : "Driver"),
                React.createElement("div", { className: "justify-content-center row mb-4" }, _this.renderVehicleDrivers(interaction, vehicle))),
            React.createElement("div", { className: "no-gutters" },
                React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Car usage"),
                React.createElement("div", { className: "justify-content-center row mb-4 pl-4 pr-4" }, vehicle.businessUse === true ? "Business use excluding commercial travelling"
                    : "Social domestic and pleasure including commuting to one place to work")))); });
    };
    QuoteSummaryPanelWidget.prototype.renderDriversDetails = function (interaction) {
        var _this = this;
        var policyHolder = interaction.policyHolder;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "summary-contents" },
                React.createElement("div", { className: "summary-contents-header" },
                    React.createElement("img", { className: "driver-icon", src: "/img/driver-icon.svg", alt: "Vehicle icon" }),
                    React.createElement("div", { className: "subject" }, "".concat(interaction.policyHolder.firstName, " ").concat(interaction.policyHolder.lastName)),
                    React.createElement("div", { className: "link-edit" },
                        React.createElement("a", { onClick: function () { return _this.navigateToEditPolicyHolder(); } }, "Edit"))),
                React.createElement("div", { className: "no-gutters" },
                    React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Date of birth"),
                    React.createElement("div", { className: "justify-content-center row mb-4" }, (0, commonFunctions_1.convertDate)(policyHolder.dateOfBirth, "DD MMMM YYYY"))),
                policyHolder.dlnLookupCallSucess && React.createElement("div", { className: "no-gutters" },
                    React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Driving licence number"),
                    React.createElement("div", { className: "justify-content-center row mb-4" }, policyHolder.licence.number)),
                React.createElement("div", { className: "no-gutters" },
                    React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Address"),
                    React.createElement("div", { className: "justify-content-center row mb-4" }, policyHolder.address.fullAddress)),
                React.createElement("div", { className: "no-gutters" },
                    React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Email"),
                    React.createElement("div", { className: "justify-content-center row mb-4 word-break" }, policyHolder.email))),
            interaction.additionalDrivers && interaction.additionalDrivers.length > 0 && this.renderAdditionalDrivers(interaction)));
    };
    QuoteSummaryPanelWidget.prototype.renderExtraProtectionIncluded = function (vehicles, extraProtectionName) {
        var vehiclesWithExtraProtection = vehicles.filter(function (vehicle) { return vehicle.extraProtection[extraProtectionName]; });
        if (vehiclesWithExtraProtection.length === 0) {
            return React.createElement("div", null, "Not included");
        }
        if (vehiclesWithExtraProtection.length > 1) {
            return React.createElement("div", null,
                React.createElement("span", null, "Included for:"),
                React.createElement("ul", { className: "multiple-cars-ul" }, vehiclesWithExtraProtection.map(function (vehicle, index) { return (React.createElement("li", { key: index, className: "multiple-cars-li" }, "".concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")"))); })));
        }
        return vehiclesWithExtraProtection.map(function (vehicle, index) { return (React.createElement("div", { key: index },
            React.createElement("span", null, "Included"), " for ".concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")"))); });
    };
    QuoteSummaryPanelWidget.prototype.renderVehicleDrivers = function (interaction, vehicle) {
        var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
        var vehicleDrivers = [];
        if (vehicle.driverIds) {
            vehicleDrivers = vehicle.driverIds.map(function (driverId) { return allDrivers.find(function (driver) { return driverId === driver.personId; }); });
        }
        return vehicleDrivers.map(function (driver, index) {
            return (React.createElement("div", { key: index }, "".concat(driver.firstName, " ").concat(driver.lastName),
                " ",
                driver.personId === vehicle.mainDriverId && React.createElement("span", { className: "main-driver" }, "(main driver)")));
        });
    };
    QuoteSummaryPanelWidget.prototype.renderAdditionalDrivers = function (interaction) {
        var _this = this;
        var vehicleAdditionalDrivers = this.getVehiclesAdditionalDrivers(interaction);
        if (vehicleAdditionalDrivers.length > 0) {
            return vehicleAdditionalDrivers.map(function (driver, index) {
                var _a;
                return (React.createElement("div", { key: index, className: "summary-contents" },
                    React.createElement("div", { className: "summary-contents-header" },
                        React.createElement("img", { className: "driver-icon", src: "/img/driver-icon.svg", alt: "Driver icon" }),
                        React.createElement("div", { className: "subject" }, "".concat(driver.firstName, " ").concat(driver.lastName)),
                        React.createElement("div", { className: "link-edit" },
                            React.createElement("a", { onClick: function () { return _this.navigateToEditAdditionalDriver(index); } }, "Edit"))),
                    React.createElement("div", { className: "no-gutters" },
                        React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Date of birth"),
                        React.createElement("div", { className: "justify-content-center row mb-4" }, (0, commonFunctions_1.convertDate)(driver.dateOfBirth, "DD MMMM YYYY"))),
                    ((_a = driver.dlnLookupData) === null || _a === void 0 ? void 0 : _a.dlnLookupCallSucess) && React.createElement("div", { className: "no-gutters" },
                        React.createElement("div", { className: "justify-content-center row font-weight-bold mb-1" }, "Driving licence number"),
                        React.createElement("div", { className: "justify-content-center row mb-4" }, driver.licence.number))));
            });
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    QuoteSummaryPanelWidget.prototype.navigateToEditCar = function (vehicleIndex) {
        this.props.engine.navigate("editVehicle".concat(vehicleIndex, "RegistrationNumberPage"), false);
    };
    QuoteSummaryPanelWidget.prototype.navigateToEditPolicyHolder = function () {
        this.props.engine.navigate("drivingLicenceScan", false);
    };
    QuoteSummaryPanelWidget.prototype.navigateToEditAdditionalDriver = function (driverIndex) {
        this.props.engine.navigate("editDriver".concat(driverIndex + 1, "DrivingLicenceScanPage"), false);
    };
    return QuoteSummaryPanelWidget;
}(LookupWidgetBase_1.LookupWidgetBase));
exports.QuoteSummaryPanelWidget = QuoteSummaryPanelWidget;
//# sourceMappingURL=QuoteSummaryPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/QuoteSummaryPanelWidget.js
// module id = 3166
// module chunks = 0